import { createUserManager } from 'redux-oidc';
import { oidcSettings } from 'etc/settings';

const userManager = createUserManager(oidcSettings);

export default userManager;
